import './bootstrap';
import '../css/app.css';
import '../css/fonts.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import * as Sentry from "@sentry/vue";

const appName = import.meta.env.VITE_APP_NAME || 'Gina Betbeze';

const handleScrollToAnchor = () => {
    setTimeout(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.getElementById(hash);
            if (element) {
                element.scrollIntoView({behavior: 'smooth'});
            }
        }
    }, 150);
}

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        Sentry.init({
            app,
            dsn: import.meta.env.SENTRY_LARAVEL_DSN,
            environment: import.meta.env.APP_ENV,
        });

        app.use(plugin)
            .use(ZiggyVue)
            .mount(el);
        return app;
    },
    progress: {
        delay: 0,
        color: import.meta.env.VITE_THEME_COLOR || '#DBB',
        // Whether to include the default NProgress styles...
        includeCSS: true,

        // Whether the NProgress spinner will be shown...
        showSpinner: true,
    },
    preserveScroll: true
});
